export const logoutDialogViewTexts = {
  title: 'ログアウトしますか？',
  description: '保存していないデータは失われます。',
  cancel: 'キャンセルする',
  ok: 'ログアウトする'
} as const;
